import { render } from "./AdvertisPublish.vue?vue&type=template&id=536e703c&scoped=true&ts=true"
import script from "./AdvertisPublish.vue?vue&type=script&lang=ts"
export * from "./AdvertisPublish.vue?vue&type=script&lang=ts"

import "./AdvertisPublish.vue?vue&type=style&index=0&id=536e703c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536e703c"]])

export default __exports__